import { createContext, useReducer, useEffect } from "react";
import * as storage from '@utils/storage'
import { favMenuActionTypes } from '@utils/constants';

// Define initial state
const initialState = {
    type: null,
    favouritesMenus: null
};

// Define reducer
const connectionReducer = (state, action) => {
    switch (action.type) {
        case favMenuActionTypes.SET_FAV_MENU:
            return { ...state, type: action.type, favouritesMenus: action.payload }; // action.payload : represent code list of all favourites menus
        case favMenuActionTypes.ADD_TO_FAV_MENU:
            return { ...state, type: action.type, favouritesMenus: [...state.favouritesMenus, action.payload] }; // action.payload : represent the code menu to add
        case favMenuActionTypes.REMOVE_FROM_FAV_MENU:
            const favouritesMenus = state.favouritesMenus.filter(cdMenu => cdMenu !== action.payload);  // action.payload : represent the code menu to remove
            return { ...state, type: action.type, favouritesMenus };
    };
};

// Create context
export const FavouritesMenusContext = createContext();

export const FavouritesMenusProvider = ({ children }) => {

    const [favMenuState, favMenuDispatch] = useReducer(connectionReducer, initialState);

    useEffect(() => {
        if (favMenuState.type) {
            switch (favMenuState.type) {
                case favMenuActionTypes.ADD_TO_FAV_MENU:
                    break;
                case favMenuActionTypes.REMOVE_FROM_FAV_MENU:
                    break;
            }

            storage.saveFavouritesMenus(favMenuState.favouritesMenus);
        }        
    }, [favMenuState.favouritesMenus]);

    return (
        <div>
            <FavouritesMenusContext.Provider value={{ favMenuState, favMenuDispatch }}>
                {children}
            </FavouritesMenusContext.Provider>
        </div>
    );
};
